export function Logo({ type = `color` }) {
  return (
    <img
      className={ `h-12 w-auto` }
      src={ `/img/logo-${type}.png` }
      alt={ `Paidnice` }
    />
  );
}
